import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function List({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.50101 2.5C5.88134 2.5 7.00049 3.61956 7.00049 4.99948C7.00049 6.38108 5.88174 7.50104 4.50101 7.50104C3.11944 7.50104 2.00049 6.38128 2.00049 4.99948C2.00049 3.61936 3.11984 2.5 4.50101 2.5ZM4.50101 3.54188C3.69526 3.54188 3.04237 4.19477 3.04237 4.99948C3.04237 5.80603 3.69502 6.45916 4.50101 6.45916C5.30607 6.45916 5.9586 5.80591 5.9586 4.99948C5.9586 4.19489 5.30583 3.54188 4.50101 3.54188ZM10.1001 4.5H21.5001C21.7762 4.5 22.0001 4.72386 22.0001 5C22.0001 5.27614 21.7762 5.5 21.5001 5.5H10.1001C9.82395 5.5 9.60009 5.27614 9.60009 5C9.60009 4.72386 9.82395 4.5 10.1001 4.5ZM10.1001 11.5H21.5001C21.7762 11.5 22.0001 11.7239 22.0001 12C22.0001 12.2761 21.7762 12.5 21.5001 12.5H10.1001C9.82395 12.5 9.60009 12.2761 9.60009 12C9.60009 11.7239 9.82395 11.5 10.1001 11.5ZM21.5001 18.5H10.1001C9.82395 18.5 9.60009 18.7239 9.60009 19C9.60009 19.2761 9.82395 19.5 10.1001 19.5H21.5001C21.7762 19.5 22.0001 19.2761 22.0001 19C22.0001 18.7239 21.7762 18.5 21.5001 18.5ZM7.00049 19.1005C7.00049 17.7198 5.88154 16.6 4.50101 16.6C3.11964 16.6 2.00049 17.7196 2.00049 19.1005C2.00049 20.4815 3.11964 21.601 4.50101 21.601C5.88154 21.601 7.00049 20.4813 7.00049 19.1005ZM3.04237 19.1005C3.04237 18.2949 3.69514 17.6419 4.50101 17.6419C5.30595 17.6419 5.9586 18.295 5.9586 19.1005C5.9586 19.906 5.30595 20.5592 4.50101 20.5592C3.69514 20.5592 3.04237 19.9062 3.04237 19.1005ZM4.50101 9.5C5.88154 9.5 7.00049 10.6195 7.00049 12C7.00049 13.3813 5.88174 14.501 4.50101 14.501C3.11944 14.501 2.00049 13.3815 2.00049 12C2.00049 10.6193 3.11964 9.5 4.50101 9.5ZM4.50101 10.5417C3.69514 10.5417 3.04237 11.1945 3.04237 12C3.04237 12.8064 3.69502 13.4594 4.50101 13.4594C5.30607 13.4594 5.9586 12.8063 5.9586 12C5.9586 11.1947 5.30595 10.5417 4.50101 10.5417Z'
      />
    </svg>
  );
}
